$(document).ready(function () {
  var boxes = [];
  var selectedBox = {};
  var selectedVariant = {};

  setDefaults();
  function applyDiscounts() {
    //// DISCOUNT CODE COOKIES ////////

    var codeCookieValue;
    var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };
    codeCookieValue = getCookie("discount_code");

    codeCookieValuecodeCookieValue = getCookie("discount_code");
    if (codeCookieValue) {
      if (codeCookieValue == "WELCOME20") {
        $(".additional20").removeClass("hidden");
      }
    }
  }
  function formatMoney(number, decPlaces, decSep, thouSep) {
    (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === "undefined" ? "." : decSep);
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  }

  function setDefaults() {
    $(".continueButton").attr("href", "javascript:void(0)");
    $(".time-links").hide();
    updateCheckout();

    setTimeout(() => {
      $(".continueButton").attr("href", "javascript:void(0)");
    }, 300);
  }

  function updateCheckout() {
    var delivery_weeks = 4;
    if (localStorage.getItem("box-weeks") !== null) {
      delivery_weeks = localStorage.getItem("box-weeks");
    }

    var selling_plan_id = "693379957010";

    switch (String(delivery_weeks)) {
      case "4":
        selling_plan_id = "693379957010";
        break;
      case "6":
        selling_plan_id = "693380022546";
        break;
      case "8":
        selling_plan_id = "693380088082";
        break;
    }

    localStorage.setItem("box-plan", selling_plan_id);

    var product_handle = "wild-caught-alaskan-salmon-box";

    switch (localStorage.getItem("box-food")) {
      case "whitefish":
        product_handle = "alaskan-whitefish-subscription-box";
        break;
      case "crab":
        product_handle = "alaskan-crab-variety-subscription-box";
        break;
      case "fishvariety":
        product_handle = "alaskan-fish-variety-subscription-box";
        break;
    }

    var ajaxUrl =
      window.Shopify.routes.root + "products/" + product_handle + ".js";

    $.ajax({
      url: ajaxUrl,
      type: "get",
      dataType: "json",
      success: function (product) {
        function addSamplePack(handle) {
          var checkoutURL = "";

          var product = {
            variant: null,
            image: null,
          };

          switch (handle) {
            case "alaskan-sockeye-salmon-subscription-box":
              product.title = "Salmon Sampler Box";
              product.variant = "50408581890322";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
            case "alaskan-fish-variety-subscription-box":
              product.title = "Variety Sampler Box";
              product.variant = "50408538145042";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
            case "alaskan-whitefish-subscription-box":
              product.title = "White Fish Sampler Box";
              product.variant = "50408581923090";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
          }

          if (product.image != null) {
            var returnURL =
              "/cart/add?items[][id]=" +
              product.variant +
              "&items[][quantity]=1";

            returnURL = "/cart/" + product.variant + ":1";

            var checkoutURL =
              "https://nettotableseafoods.com/cart/clear?return_to=" +
              encodeURIComponent(returnURL);

            boxes[product.variant] = checkoutURL;
          }
        }

        if (product) {
          $("#product-customizer-cards").html("");

          var selling_plan_id = localStorage.getItem("box-plan");

          const skioSellingPlanGroups = product.selling_plan_groups.filter(
            (group) => group.app_id === "SKIO"
          );

          addSamplePack(product.handle);

          for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];

            if (!variant.available) {
              continue;
            }

            var active_selling_plan = null;

            for (var j = 0; j < variant.selling_plan_allocations.length; j++) {
              var alloc = variant.selling_plan_allocations[j];
              const isSkio = skioSellingPlanGroups.some(
                (group) => group.id === alloc.selling_plan_group_id
              );

              if (String(alloc.selling_plan_id) == selling_plan_id && isSkio) {
                active_selling_plan = variant.selling_plan_allocations[j];
              }
            }

            if (!active_selling_plan) {
              continue;
            }

            var timeFrame = "Every " + delivery_weeks + " weeks";

            switch (delivery_weeks) {
              case "4":
                timeFrame = "Every month";
                break;
              case "8":
                timeFrame = "Every Other Month";
                break;
              case "16":
                timeFrame = "Every Two Months";
                break;
            }

            var totalWeight = 0;
            var meals = 0;
            var perPortionText = "";
            var priceExtraText = "";
            var codeCookieValue = getCookie("discount_code");
            if (codeCookieValue) {
              const info = window.discountManager.discountCookieToInfoMap.get(codeCookieValue);
              if (info) {
                priceExtraText = info.priceDescriptor;
              }

              if (codeCookieValue == "WELCOME20") {
                active_selling_plan.price = active_selling_plan.price * 0.8;
              }
            }

            var priceNumber = active_selling_plan.price / 100;

            var priceFormatted = "$" + formatMoney(priceNumber, 0);
            var priceCompareString =
              variant.price != active_selling_plan.price
                ? "$" + formatMoney(variant.price / 100, 0)
                : "";

            var savingsPercent =
              (active_selling_plan.compare_at_price -
                active_selling_plan.price) /
              active_selling_plan.compare_at_price;
            var savingsString =
              savingsPercent > 0
                ? "SAVE " + parseInt(savingsPercent * 100) + "%"
                : null;

            if (
              variant.title.includes("4.5 lbs") &&
              !variant.title.includes("Only")
            ) {
              meals = 12;
              totalWeight = "4.5 lbs";
            } else if (variant.title.includes("9 lbs")) {
              meals = 24;
              totalWeight = "9 lbs";
            }

            if (meals > 0) {
              var returnURL =
                "/cart/add?items[][id]=" +
                variant.id +
                "&items[][quantity]=1&items[][selling_plan]=" +
                selling_plan_id +
                "&return_to=/checkout";

              var discountCookie = getCookie("discount_code");
              if (discountCookie) {
                returnURL =
                  returnURL +
                  "?discount=" +
                  discountCookie +
                  "&discount=FREESALMONSPREAD";
              }

              var checkoutURL = returnURL;
              var productURL = product.url;

              var packTitle = totalWeight + " " + product.title;

              $("#product-customizer-cards").loadTemplate(
                $("#template"),
                {
                  variantId: variant.id,
                  productName: product.title,
                  deliveryWeeks: delivery_weeks,
                  sellingPlan: selling_plan_id,
                  portions: meals,
                  packTitle: packTitle,
                  subText: "subtext",
                  timeFrame: timeFrame,
                  originalPrice: priceCompareString,
                  price: priceFormatted,
                  mainImage: product.featured_image,
                  savingsPercent: savingsString,
                  mainText: "mainText",
                  priceExtra: priceExtraText,
                  blueButtonCTA: "Select Box",
                  blueButtonURL: checkoutURL,
                  secondButtonCTA: "View More Details",
                  secondButtonURL: productURL,
                  productURL: productURL,
                  checkoutURL: checkoutURL,
                },
                { append: true, async: true }
              );

              boxes[variant.id] = checkoutURL;

              $("#" + delivery_weeks + "weeks").addClass("active");

              $(".timeFrame").text(timeFrame);
            }
          }

          selectedVariant = localStorage.getItem("box-variant");
          if (
            selectedVariant !== null &&
            $("#" + selectedVariant).length != 0
          ) {
            $("#" + selectedVariant)
              .prop("checked", true)
              .trigger("click");
          } else {
            $("#product-customizer-cards .sub-select-card:first-child input")
              .prop("checked", true)
              .trigger("click");
          }
          applyDiscounts();
        }
      },
    });
  }

  $(window).on("unload", function () {
    $("#checkout-button span").show();
    $(".lds-ellipsis").remove();
    $("#checkout-button").prop("disabled", false);
  });

  $(document).on("click", ".changeTime", function () {
    $(".changeTime").hide();
    $(".time-links").show();
  });

  $(document).on("click", ".time-link", function () {
    var weeks = $(this).data("weeks");
    localStorage.setItem("box-weeks", weeks);
    $(".time-links").hide();
    $(".changeTime").show();
    updateCheckout();
  });

  $(document).on(" click", "input[name='boxsize']", function (e) {
    var variantId = $("input[name=boxsize]:checked").val();
    localStorage.setItem("box-variant", variantId);

    $(".continueButton").addClass("shake-action");
    setTimeout(function () {
      $(".continueButton").removeClass("shake-action");
    }, 1000);
  });

  $(document).on("click", ".continueButton", function () {
    $(this)
      .find("span")
      .after(
        '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
      );

    $(this).find("span").hide();
    $(this).prop("disabled", true);
    addToCart();
  });

  function addToCart() {
    var variantId = localStorage.getItem("box-variant");
    var sellingPlan = localStorage.getItem("box-plan");
    var items = [];

    items.push({
      quantity: 1,
      id: variantId,
      selling_plan: sellingPlan,
    });

    var cartUrl = "/checkout";

    var ajaxUrl = window.Shopify.routes.root + "cart/add.js";

    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        items: items,
      },
      dataType: "json",
      success: function (data) {
        location.href = cartUrl;
      },
      error: function (e) {
        alert("error", e);
      },
    });
  }
});
